import styled from "@emotion/styled";
import { gutterSizes, colorVariables } from "@gumtree/ui-library/src/base/theme";
import { newLayout } from "../../app.style";

export const PetsAdvisory = styled.div<{ isMobileCardsLayout?: boolean }>`
    border: 1px solid ${colorVariables.borderLight};
    margin: ${gutterSizes.base} 0;

    ${({ isMobileCardsLayout }) => isMobileCardsLayout && newLayout}
`;

export const PetsAdvisoryContent = styled.div`
    padding: ${gutterSizes.large};
`;

export const PetsAdvisoryText = styled.p`
    margin: 0;
`;

export const PetsAdvisoryImage = styled.img`
    float: left;
    padding-right: ${gutterSizes.medium};
`;
